import { useRouteMatch } from 'react-router-dom';

import { routes } from 'src/core/constants/routes';

/**
 * Hook into the page location by matching the route.
 */
export function useInvoicePageLocation():
  | 'schedule'
  | 'review'
  | 'confirm'
  | undefined {
  const isSchedule = useRouteMatch(routes.INVOICES_PAY.path);
  const isConfirm = useRouteMatch(routes.INVOICES_CONFIRM.path);
  const isReview = useRouteMatch(routes.INVOICES_REVIEW.path);

  if (isReview) {
    return 'review';
  }

  if (isSchedule) {
    return 'schedule';
  }

  if (isConfirm) {
    return 'confirm';
  }

  
}
